<template>
  <div class="press-feature">
    <div class="press-feature__title" style="flex: 2">
      <TwinColorTitle>In the <em>press</em></TwinColorTitle>
      <p>What's new? Here's the latest on us</p>
    </div>
    <div class="press-feature__grid" style="flex: 5">
      <Card
        v-for="item in pressItems"
        :key="item.imageProps.src"
        class="press-feature__grid-item"
        @click="() => openLinkInNewTab(item.link)"
      >
        <div class="press-feature__grid-item-image-container">
          <img
            class="press-feature__grid-item-image"
            :src="item.imageProps.src"
            :alt="item.imageProps.alt"
            :style="{
              height: item.imageProps.height ? `${item.imageProps.height}px` : undefined,
            }"
          />
        </div>

        <div class="press-feature__grid-item-content">{{ item.title }}</div>
        <a> Read more <i class="icon icon-arrow-right-1 icon--xs"></i> </a>
      </Card>
    </div>
  </div>
</template>

<script setup lang="ts">
import TwinColorTitle from '@/components/Theme2/TwinColorTitle.vue'
import Card from './Theme2/Card.vue'
import { type PressItem } from '@/constants/pressCoverage'

defineProps<{
  pressItems: PressItem[]
}>()

const openLinkInNewTab = (link: string) => {
  window.open(link, '_blank')
}
</script>
<style lang="scss" scoped>
.press-feature {
  display: flex;
  flex-direction: row;

  @include desktop {
    gap: 24px;
    align-items: center;
  }

  @include mobile {
    flex-direction: column;
  }
}

.press-feature__title,
.press-feature__title:deep(header) {
  text-align: left;

  @include mobile {
    text-align: center;
  }
}

.press-feature__grid {
  padding: 6px;
  gap: 24px;
  max-width: 70vw;
  overflow-x: scroll;
  @include hide-scrollbar;

  @include desktop {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    min-height: 220px;
  }

  @include mobile {
    @include main-unwrap;

    padding-inline: var(--site-px);
    display: flex;
    flex-direction: row;
    max-width: 100vw;
    padding-block: 10px;
    min-height: 260px;
  }
}

.press-feature__grid-item {
  @include flex-column;
  align-items: flex-start;
  min-width: 240px;
  gap: 20px;
}

.press-feature__grid-item-image-container {
  height: 35px;
  @include flex-column;
  align-items: flex-start;
  justify-content: center;
}

.press-feature__grid-item-image {
  height: 35px;
  object-fit: contain;
}

.press-feature__grid-item-content {
  flex: 1;
}

.press-feature__grid-item a {
  color: $brand-tertiary;
}
</style>
